<template>
  <!-- 名称 邮箱 照片 -->
  <div class="expertDetail">
    <div class="title_box">
      <h4>外籍讲者详情</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回</el-button>
    </div>
    <el-card>
      <div class="introduce">
        <div style="margin-top: 3px;">
          <div class="header">
            <el-image v-if="!detailsInfo.photo">
              <div
                class="r_sbox-img-slot"
                slot="error"
              >暂无</div>
            </el-image>
            <img
              v-else
              :src="detailsInfo.photo"
            >
          </div>
        </div>
        <div class="line"></div>
        <div class="discribtion">
          <h5>{{detailsInfo.name}}</h5>
          <div class="expertDetail-taitou">
            <div class="expertDetail-taitou-box">
              <div class="expertDetail-taitou-box-text">城市/国家：</div>
              <div
                class="expertDetail-taitou-box-text-q"
                v-if="detailsInfo.country"
              >
                {{detailsInfo.country}}
              </div>
              <div
                v-else
                class="expertDetail-taitou-box-text-q"
              >暂无数据</div>
            </div>
            <div class="expertDetail-taitou-box">
              <div class="expertDetail-taitou-box-text">时区时差：</div>
              <div
                class="expertDetail-taitou-box-text-q"
                v-if="detailsInfo.time_zone"
              >
                {{detailsInfo.time_zone}}
              </div>
              <div
                v-else
                class="expertDetail-taitou-box-text-q"
              >暂无数据</div>
            </div>
            <div class="expertDetail-taitou-box">
              <div class="expertDetail-taitou-box-text">医疗领域：</div>
              <div
                class="expertDetail-taitou-box-text-q"
                v-if="detailsInfo.medical_category"
              >
                {{detailsInfo.medical_category}}
              </div>
              <div
                v-else
                class="expertDetail-taitou-box-text-q"
              >暂无数据</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 下测内容 -->
    <div class="b_box">
      <div class="b_box-ul">
        <!-- //1 -->
        <ul class="b_box-ul-box1">
          <li class="b_box-ul-item">
            <h5>就职机构及职位</h5>
            <span
              v-if="!detailsInfo.institution"
              class="available"
            >暂无数据
            </span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="detailsInfo.institution"
              placement="top"
            >
              <p class="b_box-ul-item-p">
                {{detailsInfo.institution}}
              </p>
            </el-tooltip>
          </li>

          <li class="b_box-ul-item">
            <h5>演讲研究赞助商</h5>
            <span
              v-if="!detailsInfo.research_sponsor"
              class="available"
            >暂无数据
            </span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="detailsInfo.research_sponsor"
              placement="top"
            >
              <p class="b_box-ul-item-p">
                {{detailsInfo.research_sponsor}}
              </p>
            </el-tooltip>
          </li>

          <!-- <li class="b_box-ul-item">
            <h5>信息来源网页</h5>
            <span
              v-if="!detailsInfo.information_website"
              class="available"
            >暂无数据
            </span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="detailsInfo.information_website"
              placement="top"
            > 
              <p
                class="b_box-ul-item-p"
                @click="jumpClick(detailsInfo.information_website)"
              >
                {{detailsInfo.information_website}}
              </p>
            </el-tooltip>
          </li> -->
        </ul>
        <!-- //1 -->
        <!-- //2 -->
        <ul class="b_box-ul-box2">
          <li class="b_box-ul-item">
            <h5>擅长领域</h5>
            <span
              v-if="!detailsInfo.areas_of_expertise"
              class="available"
            >暂无数据
            </span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="detailsInfo.areas_of_expertise"
              placement="top"
            >
              <p class="b_box-ul-item-p">
                {{detailsInfo.areas_of_expertise}}
              </p>
            </el-tooltip>
          </li>
          <li class="b_box-ul-item">
            <h5>学协会及任职</h5>
            <span
              v-if="!detailsInfo.association"
              class="available"
            >暂无数据
            </span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="detailsInfo.association"
              placement="top"
            >
              <p class="b_box-ul-item-p">
                {{detailsInfo.association}}
              </p>
            </el-tooltip>
          </li>
        </ul>
        <!-- //2 -->
        <!-- //3 -->
        <ul class="b_box-ul-box3">
          <li class="b_box-ul-item">
            <h5>会议演讲及题目</h5>
            <span
              v-if="!detailsInfo.presenting_meeting"
              class="available"
            >暂无数据
            </span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="detailsInfo.presenting_meeting"
              placement="top"
            >
              <p class="b_box-ul-item-p">
                {{detailsInfo.presenting_meeting}}
              </p>
            </el-tooltip>
          </li>
          <li class="b_box-ul-item">
            <h5>期刊及任职及影响因子</h5>
            <span
              v-if="!detailsInfo.journal_position"
              class="available"
            >暂无数据
            </span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="detailsInfo.journal_position"
              placement="top"
            >
              <p class="b_box-ul-item-p">
                {{detailsInfo.journal_position}}
              </p>
            </el-tooltip>
          </li>
        </ul>
        <!-- //3 -->
      </div>
    </div>
    <!-- 下测内容 结束 -->
    <!-- <div v-html="detailsInfo.note"></div> -->
  </div>
</template> 
 
<script>
export default {
  name: 'expertDetail',
  data () {
    return {
      detailsInfo: {}
    }
  },
  created () {
    this.getDetails(this.$route.query.id)
  },
  methods: {
    async getDetails (id) {
      const { data: data } = await this.$http.post("speaker/detail", { id })
      this.detailsInfo = data.data
    },
    //信息来源网页
    jumpClick (url) {
      window.open(url)
    },
    //返回 
    backProject () {
      this.$router.back()
    }
  },

}
</script>

<style lang='less' scoped>
.expertDetail {
  width: 100%;
  /deep/ .el-card__body {
    padding: 33px;
  }
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .title {
    color: #212529;
    font-size: 28px;
    padding-bottom: 11px;
    border-bottom: 1px solid #e8e8e8;
  }
  .el-card {
    margin-top: 20px;
    .introduce {
      width: 100%;
      display: flex;
      // align-items: center;
      .header {
        width: 95px;
        height: 95px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .names {
        color: #9a9b9d;
        font-size: 16px;
        text-align: center;
        margin-top: 10px;
      }
    }
    .line {
      min-height: 100px;
      background: #e4e4e4;
      width: 1px;
      margin-left: 36px;
    }
    .discribtion {
      flex: 1;
      margin-left: 21px;
      h5 {
        font-size: 16px;
        color: #212529;
        margin-bottom: 62px;
      }
      .expertDetail-taitou {
        display: flex;
        .expertDetail-taitou-box {
          display: flex;
          align-items: center;
          margin-right: 100px;
          .expertDetail-taitou-box-text {
            font-size: 13px;
            color: #272727;
          }
          .expertDetail-taitou-box-text-q {
            font-size: 13px;
            color: #c7c7c7;
          }
        }
      }
    }
  }
  // 下册内容
  .b_box {
    margin-top: 40px;
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
    padding: 38px 32px;
    .b_box-ul {
      width: 100%;
      height: 100%;
      display: flex;
      .b_box-ul-box1 {
        width: 33.3%;
        // background-color: rgb(141, 235, 132);
        h5 {
          font-size: 16px;
          color: #212529;
          margin-bottom: 25px;
        }
        .b_box-ul-item {
          cursor: pointer;
          padding: 25px;
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          &:nth-child(1) {
            height: 315px;
            .b_box-ul-item-p {
              font-size: 13px;
              color: #212529;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 10;
              -webkit-box-orient: vertical;
            }
          }
          &:nth-child(2) {
            height: 158px;
            margin: 33px 0;
            .b_box-ul-item-p {
              font-size: 13px;
              color: #212529;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
          &:nth-child(3) {
            height: 194px;
            .b_box-ul-item-p {
              font-size: 13px;
              color: #6167aa;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 5;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      .b_box-ul-box2 {
        margin: 0 27px;
        width: 33.3%;
        // background-color: rgb(102, 168, 230);
        h5 {
          font-size: 16px;
          color: #212529;
          margin-bottom: 25px;
        }
        .b_box-ul-item {
          cursor: pointer;
          padding: 25px;
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          &:nth-child(1) {
            height: 315px;
            .b_box-ul-item-p {
              font-size: 13px;
              color: #212529;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 11;
              -webkit-box-orient: vertical;
            }
          }

          &:nth-child(2) {
            margin-top: 33px;
            height: 386px;
            .b_box-ul-item-p {
              font-size: 13px;
              color: #212529;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 15;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      .b_box-ul-box3 {
        width: 33.3%;
        // background-color: rgb(233, 166, 78);
        h5 {
          font-size: 16px;
          color: #212529;
          margin-bottom: 25px;
        }
        .b_box-ul-item {
          cursor: pointer;
          padding: 25px;
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          &:nth-child(1) {
            height: 315px;
            .b_box-ul-item-p {
              font-size: 13px;
              color: #212529;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 11;
              -webkit-box-orient: vertical;
            }
          }

          &:nth-child(2) {
            margin-top: 33px;
            height: 386px;
            .b_box-ul-item-p {
              font-size: 13px;
              color: #212529;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 15;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }
  .available {
    display: flex;
    margin-top: 20px;
  }

  .pictures {
    margin-top: 25px;
    width: 90px;
    height: 90px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-image {
    width: 100% !important;
    height: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    .r_sbox-img-slot {
      font-size: 14px;
      color: #c0c4cc;
      vertical-align: middle;
    }
  }

  .picturessss {
    width: 90px;
    height: 90px;
    margin: 20px 0 25px 0;
    // margin-bottom: 25px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
